export const serviceConnectionCMS = [
	{
		name: 'Для интернет-магазинов 1С-Битрикс',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/1c-bitrix',
	},
	{
		name: 'Для интернет-магазинов на WooCommerce',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/wordpress',
	},
	{
		name: 'Для интернет-магазинов 1С-Битрикс 24',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/bitrix24',
	},
	{
		name: 'Для интернет-магазинов Битрикс24',
		location: 'Подключение: Модули для CRM',
		url: '/integration/crm/bitrix24',
	},
	{
		name: 'Для интернет-магазинов AmoCRM',
		location: 'Подключение: Модули для CRM',
		url: '/integration/crm/amocrm',
	},
	{
		name: 'Для интернет-магазинов Insales',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/insales',
	},
	{
		name: 'Для интернет-магазинов Ecwid',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/ecwid',
	},
	{
		name: 'Сервис для всех интеграций Albato',
		location: 'Подключение: Интеграции партнеров',
		url: '/integration/partners/albato',
	},
	{
		name: 'Для интернет-магазинов Amiro',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/amiro-cms',
	},
	{
		name: 'Для интернет-магазинов CSCart',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/cs-cart',
	},
	{
		name: 'Для интернет-магазинов Diafan',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/diafan-cms',
	},
	{
		name: 'Для интернет-магазинов на Drupal Commerce',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/drupal',
	},
	{
		name: 'Для интернет-магазинов HostCMS',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/hostcms',
	},
	{
		name: 'Для интернет-магазинов на Joom Shopping',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/joomla',
	},
	{
		name: 'Для интернет-магазинов на MS2',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/modx',
	},
	{
		name: 'Для интернет-магазинов MogutaCMS',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/moguta-cms',
	},
	{
		name: 'Для интернет-магазинов Netcat',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/netcat',
	},
	{
		name: 'Для интернет-магазинов OkayCMS',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/okaycms',
	},
	{
		name: 'Для интернет-магазинов OpenCart',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/opencart',
	},
	{
		name: 'Для интернет-магазинов PHPShop',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/phpshop',
	},
	{
		name: 'Для интернет-магазинов Prestashop',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/prestashop',
	},
	{
		name: 'Для интернет-магазинов ReadyScript',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/readyscript',
	},
	{
		name: 'Для интернет-магазинов UmiCMS',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/umi-cms',
	},
	{
		name: 'Для интернет-магазинов VamShop',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/vamshop',
	},
	{
		name: 'Для интернет-магазинов на Shop Script',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/webasyst',
	},
	{
		name: 'Для интернет-магазинов на Wix',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/wix',
	},
	{
		name: 'Платформа для онлайн-школ АвтоОфис',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/autooffice',
	},
	{
		name: 'Платформа для онлайн-школ АвтоОфис',
		location: 'Подключение: Модули для CRM',
		url: '/integration/crm/autooffice',
	},
	{
		name: 'Для интернет-магазинов на Веб-АвтоРесурс v.5',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/autoresource',
	},
	{
		name: 'Для автошколы Автошкола-Контроль',
		location: 'Подключение: Модули для CRM',
		url: '/integration/crm/avtoshkola-kontrol',
	},
	{
		name: 'Для интернет-магазинов ABCP',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/abcp',
	},
	{
		name: 'Для интернет-магазинов Advantshop',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/advantshop',
	},
	{
		name: 'Для интернет-магазинов AutoWebOffice',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/autoweboffice',
	},
	{
		name: 'Для интернет-магазинов AutoWebOffice',
		location: 'Подключение: Модули для CRM',
		url: '/integration/crm/autoweboffice',
	},
	{
		name: 'Прием платежей для онлайн-курсов Biz',
		location: 'Подключение: Интеграции партнеров',
		url: '/integration/partners/biz',
	},
	{
		name: 'Приложение для групп и благотворительных фондов в социальной сети ВКонтакте',
		location: 'Подключение: Интеграции партнеров',
		url: '/integration/partners/vkontakte',
	},
	{
		name: 'Для чат-центра Chat2Desk',
		location: 'Подключение: Интеграции партнеров',
		url: '/integration/partners/chat2desk',
	},
	{
		name: 'Для интернет-магазинов E-AutoPay',
		location: 'Подключение: Интеграции партнеров',
		url: '/integration/partners/e-autopay',
	},
	{
		name: 'Для интернет-магазинов EShoper',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/eshoper',
	},
	{
		name: 'Для онлайн-оплаты счетов Аспро.Cloud',
		location: 'Подключение: Модули для CRM',
		url: '/integration/crm/aspro',
	},
	{
		name: 'Для интернет-магазинов на FoodSoul',
		location: 'Подключение: Модули для CRM',
		url: '/integration/crm/foodsoul',
	},
	{
		name: 'Для интернет-магазинов GetCourse',
		location: 'Подключение: Интеграции партнеров',
		url: '/integration/partners/getcourse',
	},
	// {
	// 	name: 'Для платформы Leeloo',
	// 	location: 'Подключение: Модули для CMS',
	// 	url: '/integration/cms/leeloo',
	// },
	{
		name: 'Для интернет-магазинов Mottor',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/mottor',
	},
	{
		name: 'Сервис для управления сообществами и клубами Mangustin',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/mangustin',
	},
	{
		name: 'Для интернет-магазинов Magento',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/magento',
	},
	{
		name: 'Для онлайн-оплаты счетов МойСклад',
		location: 'Подключение: Модули для CRM',
		url: '/integration/crm/my-warehouse',
	},
	{
		name: 'Для интернет-магазинов на Parts Soft',
		location: 'Подключение: Модули для crm',
		url: '/integration/crm/parts-soft',
	},
	{
		name: 'Для интернет-магазинов на RetailCRM',
		location: 'Подключение: Модули для CRM',
		url: '/integration/crm/reatilcrm',
	},
	{
		name: 'Для интернет-магазинов',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/shopify',
	},
	{
		name: 'Для чатботов и&nbsp;месcенджеров',
		location: 'Подключение: Интеграции партнеров',
		url: '/integration/partners/smartsender',
	},
	{
		name: 'Для интернет-магазинов в Instagram',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/taplink',
	},
	{
		name: 'Для интернет-магазинов на Tilda',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/tilda',
	},
	{
		name: 'Для интернет-магазинов Ucoz',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms/ucoz',
	},
	{
		name: 'Онлайн-сервис финансового и управленческого учета для вашего бизнеса ФинТабло',
		location: 'Подключение: Интеграции партнеров',
		url: '/integration/partners/fintablo',
	},
	{
		name: 'Для интернет-магазинов Verbox',
		location: 'Подключение: Интеграции партнеров',
		url: '/integration/partners/verbox',
	},
	{
		name: 'Платежный модуль CloudPayments для HDE',
		location: 'Подключение: Модули партнеров',
		url: '/integration/partners/hde',
	},
	{
		name: '',
		location: 'Подключение: Модули для CRM',
		url: '/integration/partners/alsacrm',
	},
];
